// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ANET","header":"Messages_header__1n-V1"};